<template>
    <div class="container404" :class="size">
        <img src="../assets/img/nodata/no_data.png" alt="" class="img-404"  v-if="type === 0">
        <img src="../assets/img/nodata/no_data_active.png" alt="" class="img-404"  v-if="type === 1">
        <img src="../assets/img/nodata/no_data_apply.jpg" alt="" class="img-404" v-if="type === 2">
        <img src="../assets/img/nodata/no_data_news.png" alt="" class="img-404"  v-if="type === 3">
        <img src="../assets/img/nodata/no_data_notice.png" alt="" class="img-404" v-if="type === 4">
        <img src="../assets/img/nodata/no_data_server.jpg" alt="" class="img-404" v-if="type === 5">
    </div>
</template>

<script>
    export default {
        name: "Empty",
        data() {
            return {}
        },
        props: {
            type: {
                type: Number,
                default: 0
            },
            size: {
                type: String,
                default: ''
            },
        },
        computed: {},
        components: {},
    }
</script>

<style scoped lang="scss">
    .container404 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #ffffff;

        &.min{
            width: 100%;
            height: auto;
        }
        .img-404 {
            width: 50%;
            margin-top: 30px;
        }
        .tips{
            font-size: 32px;
            color: #ff6b54;
            font-weight: bold;
        }
        .go-home {
            width: 109px;
            height: 40px;
            margin-top: 30px;
            background-color: #ff6b54;
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            color: #ffffff;
            cursor: pointer;
        }
    }
</style>